import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";
import axios from "axios";
import { isAdminShellBlockedError, shouldBlockWorkApi } from "./common/auth/tutor-admin-auth";

import store from "./store";

axios.interceptors.response.use(
  response => response,
  error => {
    if (isAdminShellBlockedError(error) && shouldBlockWorkApi()) {
      return Promise.reject(Object.assign(error, { suppressedAdminShell: true }));
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
//basename="/2024/tutorapp"
root.render(
  <Provider store={store}>
    <BrowserRouter future={{
      v7_relativeSplatPath: true,
    }}>
      <App />
    </BrowserRouter>
  </Provider>
);

serviceWorker.unregister();